import React from "react";
import Skill from "./Skill";
import base from "../base";

class SkillBox extends React.Component {
  state = {
    skills: {}
  };

  componentDidMount() {
    this.ref = base.syncState('skills', {
      context: this,
      state: 'skills'
    });
  }

  componentDidUpdate() {
    this.props.onChange(this.state);
  }

  render() {
    if(Object.keys(this.state.skills).length === 0) {
      return (
        <div className="section-skills-skillbox" >
          Loading...
        </div>
      );
    }
    else {
      return (
        <div className="section-skills-skillbox" >
          {Object.keys(this.state.skills).map(key =>
            <Skill key={key} icon={this.state.skills[key]['icon']} link={this.state.skills[key]['link']} name={this.state.skills[key]['name']}/>
          )}
        </div>
      )
    }
  }
}

export default SkillBox;
